//src/admin/pages/AdminShippingSettings.js
import React, { useEffect, useState, useContext } from "react";
import AdminSidebar from "../AdminSidebar";
import AdminHeader from "../AdminHeader";
import { FaSave, FaTruck } from "react-icons/fa";
import { Toaster } from "react-hot-toast";
import {
  getAdminShippingSettings,
  saveAdminShippingSettings,
} from "../../services/adminShippingSettings.api";
import { AdminLanguageContext } from "../context/AdminLanguageContext";
import toast from "react-hot-toast";

function AdminShippingSettings() {
  const { lang } = useContext(AdminLanguageContext);

  const [isOpen, setIsOpen] = useState(false);
  const [loading, setLoading] = useState(true);
  const [saving, setSaving] = useState(false);
  
  const [showConfirm, setShowConfirm] = useState(false);

  const [form, setForm] = useState({
    default_fee: 4,
    free_enabled: false,
    free_threshold: 50,
  });

  const TEXT = {
  EN: {
    title: "Shipping Settings",
    defaultFee: "Default Shipping Fee ($)",
    enableFree: "Enable Free Shipping",
    freeThreshold: "Free Shipping Threshold ($)",
    save: "Save",
    saving: "Saving…",
    loading: "Loading…",
    confirmTitle: "Save Shipping Settings",
    confirmText: "Are you sure you want to save these changes?",
    cancel: "Cancel",
    confirm: "Confirm",
    success: "Shipping settings saved successfully",
  },
  AR: {
    title: "إعدادات الشحن",
    defaultFee: "رسوم الشحن الافتراضية ($)",
    enableFree: "تفعيل الشحن المجاني",
    freeThreshold: "الحد الأدنى للشحن المجاني ($)",
    save: "حفظ",
    saving: "جارٍ الحفظ…",
    loading: "جارٍ التحميل…",
    confirmTitle: "حفظ إعدادات الشحن",
    confirmText: "هل أنت متأكد أنك تريد حفظ هذه التغييرات؟",
    cancel: "إلغاء",
    confirm: "تأكيد",
    success: "تم حفظ إعدادات الشحن بنجاح",
  },
};

const t = TEXT[lang];

const adminUser = JSON.parse(localStorage.getItem("adminUser") || "{}");
const perms = JSON.parse(localStorage.getItem("staffPermissions") || {});
const isAdmin = adminUser.role === "admin";
const canAccess = isAdmin || perms.can_manage_shipping;



  useEffect(() => {
    getAdminShippingSettings()
      .then(setForm)
      .finally(() => setLoading(false));
  }, []);

  const save = async () => {
  setSaving(true);
  try {
    await saveAdminShippingSettings(form);
    toast.success(t.success);
  } finally {
    setSaving(false);
    setShowConfirm(false);
  }
};

  return (
    <div className={`flex bg-gray-100 min-h-screen ${isOpen ? "overflow-hidden" : ""}`}>
  
  {/* ✅ TOAST RENDERER (PAGE-LOCAL) */}
  <Toaster
    position={lang === "AR" ? "top-left" : "top-right"}
    toastOptions={{
      duration: 3000,
      style: {
        borderRadius: "12px",
        fontWeight: "600",
      },
    }}
  />

  <AdminSidebar isOpen={isOpen} setIsOpen={setIsOpen} />
  <div className="flex-1 lg:ml-64">

        <AdminHeader setIsOpen={setIsOpen} />

        <main className="p-6 max-w-xl mx-auto">
  {!canAccess && (
    <div className="bg-red-50 border border-red-200 rounded-xl p-6 text-center">
      <p className="text-red-700 font-semibold">
        {lang === "AR"
          ? "ليس لديك صلاحية لإدارة إعدادات الشحن"
          : "You do not have permission to manage shipping settings."}
      </p>
    </div>
  )}

  {canAccess && (
    <>

          <h1 className="text-2xl font-bold text-cyan-700 flex items-center gap-2 mb-6">
            <FaTruck /> {t.title}
          </h1>

          {loading ? (
            <p>{t.loading}</p>
          ) : (
            <div className="bg-white p-6 rounded-xl shadow space-y-4">
              <div>
                <label className="font-semibold">{t.defaultFee}</label>
                <input
                  type="number"
                  className="w-full p-3 border rounded-xl mt-1"
                  value={form.default_fee}
                  onChange={(e) =>
                    setForm({ ...form, default_fee: Number(e.target.value) })
                  }
                />
              </div>

              <label className="flex items-center gap-3">
  <input
    type="checkbox"
    checked={form.free_enabled}
    onChange={(e) =>
      setForm({ ...form, free_enabled: e.target.checked })
    }
  />
  {t.enableFree}
</label>

              {form.free_enabled && (
                <div>
                  <label className="font-semibold">
                    {t.freeThreshold}
                  </label>
                  <input
                    type="number"
                    className="w-full p-3 border rounded-xl mt-1"
                    value={form.free_threshold}
                    onChange={(e) =>
                      setForm({
                        ...form,
                        free_threshold: Number(e.target.value),
                      })
                    }
                  />
                </div>
              )}

              <button
  onClick={() => setShowConfirm(true)}
  disabled={saving}
  className="bg-cyan-600 hover:bg-cyan-700 transition
             text-white px-6 py-3 rounded-xl
             flex items-center gap-2"
>
  <FaSave /> {saving ? t.saving : t.save}
</button>

            </div>
          )}

          {showConfirm && (
  <div className="fixed inset-0 bg-black/40 flex items-center justify-center z-50">
    <div className="bg-white rounded-xl p-6 w-[360px] shadow-xl">
      <h3 className="text-lg font-bold mb-2 text-gray-800">
        {t.confirmTitle}
      </h3>

      <p className="text-sm text-gray-600 mb-6">
        {t.confirmText}
      </p>

      <div className="flex justify-end gap-3">
        <button
          onClick={() => setShowConfirm(false)}
          className="px-4 py-2 rounded-lg bg-gray-200 hover:bg-gray-300 transition"
        >
          {t.cancel}
        </button>

        <button
          onClick={save}
          disabled={saving}
          className="px-4 py-2 rounded-lg bg-cyan-600 text-white hover:bg-cyan-700 transition"
        >
          {t.confirm}
        </button>
      </div>
    </div>
  </div>
)}
    </>
  )}

        </main>
      </div>
    </div>
  );
}

export default AdminShippingSettings;
